import { Box } from "@mui/material"
import { useParams } from "@tanstack/react-router"
import type { FC } from "react"

import AccountingComments from "@/screens/CompanySettings/Accounting/components/AccountingComments"
import PaymentSettingsContainer from "@/screens/CompanySettings/Accounting/containers/PaymentSettingsContainer"
import { PaymentTermsProvider } from "@/screens/CompanySettings/Accounting/contexts/PaymentTermsContext"

const AccountingContainer: FC = () => {
  const { companyId } = useParams({ from: "/app/companies/$companyId/edit" })
  return (
    <Box className='flex h-full flex-col space-y-4'>
      <PaymentTermsProvider>
        <PaymentSettingsContainer companyId={companyId} />
        <AccountingComments companyId={companyId} />
      </PaymentTermsProvider>
    </Box>
  )
}

export default AccountingContainer
